var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlerts = function SvgAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 120c-265.22 0-480 214.78-480 480s214.78 480 480 480 480-214.78 480-480-214.78-480-480-480m49.219 813.61h-104.39V829.22h104.39zm0-175.22h-104.39L513.61 352.78l174-85.219z"
  })));
};
export default SvgAlerts;